var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height"},[_c('v-col',{attrs:{"align-self":"center"}},[_c('telepresence')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }